<div class="container mt-4">
  <div class="card shadow-sm">
    <div class="table-responsive p-3">

      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h4 class="mb-0">FINAL APPROVAL</h4>
      </div>

      <!-- Employee Table -->
      <table class="table table-bordered table-hover">
        <thead class="table-dark">
          <tr>
            <th>#</th>
            <th>Action</th>
            <th>Boarding Type</th>
            <th>Employee ID</th>
            <th>Full Name</th>
            <th>Designation</th>
            <th>Location</th>
            <th>Date of Joining</th>
            <th>Department</th>
            <th>Requester</th>
            <th>Checker</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let emp of appservice.FinalApproverdata; let i = index">
            <td>{{ i + 1 }}</td>

            <!-- Action Dropdown -->
            <td>
              <div class="dropdown">
                <button class="btn btn-secondary dropdown-toggle btn-sm" type="button" data-bs-toggle="dropdown">
                  Action
                </button>
                <ul class="dropdown-menu">
                  <li><a class="dropdown-item" (click)="approveEmployee(emp.OD_iid)">Approve</a></li>
                  <li><a class="dropdown-item" (click)="rejectEmployee(emp.OD_iid)">Reject</a></li>
                </ul>
              </div>
            </td>

            <!-- Data Columns -->
             <td>{{ emp.OD_Account_type }}</td>
            <td>{{ emp.OD_EmployeeID }}</td>
            <td>{{ emp.OD_Full_Name }}</td>
            <td>{{ emp.OD_Designation }}</td>
            <td>{{ emp.OD_Grad }}</td>
            <td>{{ emp.OD_Dateofjoin }}</td>
            <td>{{ emp.OD_Department }}</td>
            <td>{{ emp.OD_OnboardingCreatedby }}</td>
            <td>{{ emp.OD_ReportingTo_Name }}</td>
          </tr>
        </tbody>
      </table>

    </div>
  </div>
</div>
